export default "__VITE_ASSET__CU40EEtz__"